<template>
  <div>
    <div class="holiday-search__autocomplete"
        @click.stop>
      <div class="form-check search-filter-dropdown-select">
        <ul class="list-unstyled w-100">
          <li v-for="item in items" 
              :key="item.value" 
              class="filter-list__item holiday-search__autocomplete-btn">
            <label class="checkbox-label dropdown-list-item m-0">

              <input type="checkbox" 
                     :name="name" 
                     v-model="item.selected" 
                     :value="item.value" 
                     :title="item.value">

              <span class="filter-list__label m-0"
                    :class="{'fw-bold': item.selected}" 
                    :title="item.label">
                {{ item.label }}
              </span>

            </label>
          </li>
        </ul>
      </div>

      <button class="btn holiday-search__btn" 
              type="button"
              @click="applySelection" 
              aria-label="Apply selected holiday options"
              title="Apply selected holiday options">
        Done
      </button>

    </div>
  </div>
</template>

<script>
export default {
  props: ['items', 'label', 'name'],
  
  methods: {
    applySelection() {
      this.$parent[`toggle${this.label}`]();
    }
  }
};
</script>
